import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const ContentExtractModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.contentExtract,
  templateType: ModuleTemplateTypeEnum.logicDeal,
  flowType: FlowNodeTypeEnum.contentExtract,
  name: '内容提取',
  description: '从输入的文本中提取内容',
  isTool: true,
  inputs: [
    Input_Template_Switch,
    {
      type: FlowNodeInputTypeEnum.textarea,
      key: ModuleInputKeyEnum.contextExtractInput,
      label: '输入内容',
      description: '要提取信息的文本',
      showTargetInApp: true,
      showTargetInPlugin: false,
      valueType: ModuleIOValueTypeEnum.string,
      required: true,
    },
    {
      type: FlowNodeInputTypeEnum.select,
      key: ModuleInputKeyEnum.contentExtractMode,
      label: '提取类型',
      required: true,
      description: '提取文本内容的方式',
      list: [
        { label: 'json提取', value: 'json' },
        { label: '正则提取', value: 'regexp' },
      ],
      value: 'json',
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      key: ModuleInputKeyEnum.contentExtractKeys,
      type: FlowNodeInputTypeEnum.custom,
      label: '提取字段',
      valueType: ModuleIOValueTypeEnum.fieldDescription,
      description: '需要提取的json key',
      value: [], // {desc: string; key: string; required: boolean; enum: string[]}[]
      showTargetInApp: false,
      showTargetInPlugin: false,
      required: true,
    },
    {
      key: ModuleInputKeyEnum.contentExtractRegexp,
      type: FlowNodeInputTypeEnum.textarea,
      label: '提取正则',
      valueType: ModuleIOValueTypeEnum.string,
      description: '需要提取的正则表达式',
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.contextExtractSuccess,
      label: '字段全部提取完成',
      description: '字段全部提取完成时触发',
      valueType: ModuleIOValueTypeEnum.boolean,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.contextExtractFail,
      label: '字段提取缺失',
      description: '字段未全部提取完成时触发',
      valueType: ModuleIOValueTypeEnum.boolean,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.contextExtractResults,
      label: '完整提取结果',
      description: '一个 JSON 字符串，例如：{"name:":"YY","Time":"2023/7/2 18:00"}',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
    // {
    //   key: 'a',
    //   label: '提取结果-a',
    //   valueType: ModuleIOValueTypeEnum.any,
    //   type: FlowNodeOutputTypeEnum.source,
    //   targets: [],
    // },
    //...
  ],
};
